export default __webpack_public_path__ + "static/media/hand.a587454e.png";